import React, {Component,useState,useEffect} from 'react';
import axios from 'axios';
// react-router-dom v6: Redirect is replaced by Navigate; this file does client-side navigation via window.location so no import needed
import  logo from '../../assets/img/logo.png';
import GetPagesData from "../Routes";
import { trans } from "../utils";
import config from '../../config.js';
import { useSelector, useDispatch } from 'react-redux';
import { setUserProfile } from '../../reducer';
const Login = () => {
    const dispatch = useDispatch();
    const SystemUrl = config.SystemUrl;
    const [userRequest, setUserRequest] = useState({
        email: '',
        password: '',
        isLoading: false,
        errorEmail : '',
        errorPassword: '',
        location: {},
        invalidEmail : false
    });
    // Read from Redux (set by App.jsx after API call) — falls back to localStorage cache
    const reduxLogo = useSelector((state) => state.clientLogo?.url);
    const ClientLogo = (reduxLogo && reduxLogo !== '') ? reduxLogo : localStorage.getItem('ClientLogo');
    const reduxSiteClientLogo = useSelector((state) => state.siteClientLogo?.url);
    const SiteClientLogo = (reduxSiteClientLogo && reduxSiteClientLogo !== '') ? reduxSiteClientLogo : localStorage.getItem('SiteClientLogo');
    console.log('[Login] ClientLogo:', ClientLogo);
    let SystemTitle=localStorage.getItem('SystemTitle')?localStorage.getItem('SystemTitle') : "HIC - AEON";

    useEffect(() => {
        document.title = SystemTitle;
    }, [SystemTitle]);

    useEffect(() => {
        console.log("renderRedirect", userRequest.redirect, userRequest.location);
        if (userRequest.redirect === true && userRequest.location) {
            // If a last route is provided, redirect to that route
            window.location.href = userRequest.location;
        } else if (userRequest.redirect === true) {
            // Otherwise, reload the current page
            window.location.reload(true);
        }
    }, [userRequest.redirect, userRequest.location]);

    const isLoading = userRequest.isLoading;

    const handleEmailChange = event => {
        console.log("handleEmailChange")

        setUserRequest({...userRequest,email: event.target.value} );
    };
    const handlePwdChange = event => {
        setUserRequest({...userRequest,password: event.target.value} );
    };
    const handleSubmit = event => {
        event.preventDefault();
        const Sanctumurl = SystemUrl+'sanctum/csrf-cookie';
        axios.get(Sanctumurl, { headers: { 'Accept': 'application/json' } }).then(response => {
            setUserRequest({...userRequest,isLoading: true} );
            const url = SystemUrl+'login';
            const email = userRequest.email;
            const password = userRequest.password;
            let bodyFormData = new FormData();
            bodyFormData.set('email', email);
            bodyFormData.set('password', password);
            console.log("Submitting login using:", url, bodyFormData);
            axios.post(url, bodyFormData, { headers: { 'Accept': 'application/json' } })
                .then(result => {
                    console.log("Login success", result.data);
                    var pages=result.data.data.pages;
                    console.log("Pages:", pages);
                    localStorage.setItem('isLoggedIn', true)
                    localStorage.setItem('userRole', result.data.data.user.role)
                    localStorage.setItem('userProfile', JSON.stringify(result.data.data.user))
                    dispatch(setUserProfile(result.data.data.user))
                    //Refresh Routes
                    GetPagesData(pages);
                    // Hybrid Redirect Logic (Option 3 & Exact Recovery)
                    // If the user manually logged out, they go to the Dashboard
                    // If their session timed out automatically, they return to their exact last screen (or last_route optionally)
                    const isManualLogout = localStorage.getItem('is_redirect_dashboard') === "true";
                    const exactRecoveryRoute = localStorage.getItem('exact_recovery_route');
                    
                    // let redirectPath = result.data.data.user.last_route;
                    let redirectPath = '/Dashboard';


                    if (isManualLogout) {
                        redirectPath = '/Dashboard'; // Go to home/dashboard
                        localStorage.removeItem('is_redirect_dashboard'); // Clear the flag
                    } else if (exactRecoveryRoute) {
                        redirectPath = exactRecoveryRoute;
                        localStorage.removeItem('exact_recovery_route'); // Clear the flag
                    }
                 
                    console.log("Redirect path:", redirectPath);

                    setUserRequest({
                        ...userRequest,
                        redirect: true, 
                        isLoading: false, 
                        location: redirectPath
                    });
                })
                .catch(error => {
                    console.error("Login error:", error.response || error);

                    const backendErrors = error?.response?.data?.errors || {};

                    setUserRequest({
                    ...userRequest,
                    errorEmail: backendErrors.hasOwnProperty('email') ? backendErrors.email[0] : "",
                    errorPassword: backendErrors.hasOwnProperty('password') ? backendErrors.password[0] : "",
                    isLoading: false
                    });
                });

            })
            .catch(error => {
                console.error("Failed to get CSRF cookie:", error);

                setUserRequest({
                ...userRequest,
                isLoading: false,
                errorEmail: "Server unavailable. Please try again later.",
                errorPassword: ""
                });
            });
    };


    return (

        <div className="d-flex flex-column flex-root bg-temp">
             {/*// style={{ backgroundImage: `url(${background})` }}>*/}

            <div className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-cover bgi-attachment-fixed bg-login">
                <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">

                    <div className="w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto">
                        <div className="d-flex align-items-center w-100">
                            <div style={{width:'60%'}} className="d-flex justify-content-center">
                                <img alt="Logo" src={logo} className="h-60px" style={{maxWidth:'100%', objectFit:'contain'}}/>
                            </div>
                            <div style={{width:'40%'}} className="d-flex align-items-center justify-content-evenly">
                                {ClientLogo && (
                                    <img
                                        alt="ClientLogo"
                                        src={ClientLogo}
                                        className="h-60px"
                                        style={{width:'50%', maxWidth:'100%', objectFit:'contain'}}
                                        onError={(e) => { e.target.style.display='none'; }}
                                    />
                                )}
                                {SiteClientLogo && (
                                    <img
                                        alt="SiteClientLogo"
                                        src={SiteClientLogo}
                                        className="h-60px"
                                        style={{width:'50%', maxWidth:'100%', objectFit:'contain'}}
                                        onError={(e) => { e.target.style.display='none'; }}
                                    />
                                )}
                            </div>
                        </div>

                        <form className="form w-100 mt-10" noValidate="novalidate" id="kt_sign_in_form" action="#"
                              onSubmit={handleSubmit}>

                            {/*<div className="text-center mb-10">*/}

                            {/*    <h1 className="text-dark mb-3">{trans('Welcome to AEON')}</h1>*/}
                            {/*</div>*/}

                            <div className="fv-row mb-15">

                                <label className="form-label fs-6 fw-bolder text-dark">{trans('Email')}</label>
                                <input
                                    className="form-control form-control-lg form-control-solid"
                                    id="inputEmail" placeholder={trans('Email address')} type="text" name="email"
                                    onChange={handleEmailChange} autoFocus required />

                                { userRequest.errorEmail &&
                                <div className="fv-plugins-message-container text-danger">
                                    <div data-field="email" data-validator="emailAddress">{ userRequest.errorEmail } </div>
                                </div> }


                            </div>

                            <div className="fv-row mb-15">

                                <div className="d-flex flex-stack mb-2">

                                    <label className="form-label fw-bolder text-dark fs-6 mb-0">{trans('Password')}</label>
                                    <a href="/forget-password"
                                       className="link-primary fs-6 fw-bolder">Forgot Password ?</a>

                                </div>
                                <input type="password"
                                       className="form-control form-control-lg form-control-solid"
                                       id="inputPassword" placeholder={trans('Enter Your Password')} name="password"
                                       onChange={handlePwdChange} required/>
                                { userRequest.errorPassword &&
                                <div className="fv-plugins-message-container text-danger">
                                    <div data-field="email" data-validator="emailAddress">{ userRequest.errorPassword } </div>
                                </div> }

                            </div>

                            <div className="text-center">

                                <button className="btn btn-light-primary font-weight-bold mr-2" type="submit" disabled={userRequest.isLoading ? true : false}> <span className="indicator-label">{trans('Login')} </span>

                                    {isLoading ? (
                                         <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    ) : (
                                        <span></span>
                                    )}
                                </button>

                            </div>

                        </form>


                    </div>

            </div>

        </div>
        </div>
    );


}
export default  Login;
